import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { API_URL } from "../../shared/constant";
import axios from "axios";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";
import { isPWA, isMobilePWA, getPWADisplayMode } from "../../utils/pwa";
import { isWebView } from "../../utils/webview";
import "../../styles/pwa-customers.css";
const Customers = () => {
  const [customerData, setCustomerData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [customerDataOriginal, setCustomerDataOriginal] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pwaMode, setPwaMode] = useState(false);
  const [mobilePWA, setMobilePWA] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [refreshing, setRefreshing] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [webViewMode, setWebViewMode] = useState(false);



  const getCustomer = () => {  
    axios.post(API_URL.CUSTOMERS_LIST, {}).then(
      (res) => {
        if (res.data.status === 1) {
          setCustomerData(res.data.data);
           setCustomerDataOriginal(res.data.data);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,

        });
      }
    );
  };

  const deleteCustomer = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this - " + row.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.CUSTOMERS_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              let newData = customerData.filter((r) => r.id !== row.id);
              setCustomerData(newData);
            }
            toast.success(row.name + " Delete Successfully", { autoClose: 3000 });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  const approveCustomer = (row, status) => {
    Swal.fire({
      title: (status === 0) ? 'Are you sure to block this user?' : 'Are you sure to approve this?',
      text: "",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.CUSTOMERS_APPROVE, { id: row.id, status: status }).then(
          (res) => {
            if (res.data.status === 1) {
              let newIndex = customerData.findIndex((r) => r.id === row.id);
              customerData[newIndex].customer_status = status;
              setCustomerData(customerData);
            }
            toast.success(row.name + " approved Successfully", { autoClose: 3000 });
            setLoading(false);
          },
          (error) => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

const handleSearchChange = async (e) => {
  const value = e.target.value;
  setSearchValue(value);

  if (value.length >= 3) {
    try {
      const res = await axios.post(API_URL.CUSTOMERS_SEARCH, { text: value });

      if (Array.isArray(res.data)) {
        setCustomerData(res.data);
      } else if (Array.isArray(res.data.data)) {
        setCustomerData(res.data.data);
      }
    } catch (error) {
      toast.error("Search failed", { autoClose: 2000 });
    }
  } else {
    setCustomerData(customerDataOriginal);
  }
};

  // Handle online/offline status
  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (pwaMode) {
        toast.success("Connection restored", { autoClose: 2000 });
        getCustomer(); // Refresh data when back online
      }
    };
    
    const handleOffline = () => {
      setIsOnline(false);
      if (pwaMode) {
        toast.warning("You're offline. Some features may not work.", { autoClose: 3000 });
      }
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [pwaMode]);

  // Pull to refresh functionality
  useEffect(() => {
    if (!pwaMode || !mobilePWA) return;

    let startY = 0;
    let currentY = 0;
    let isPulling = false;
    let pullElement = null;

    const handleTouchStart = (e) => {
      if (window.scrollY === 0) {
        startY = e.touches[0].clientY;
        pullElement = document.querySelector('.pwa-customer-list');
      }
    };

    const handleTouchMove = (e) => {
      if (window.scrollY === 0 && pullElement) {
        currentY = e.touches[0].clientY;
        const pullDistance = currentY - startY;

        if (pullDistance > 50) {
          isPulling = true;
          pullElement.style.transform = `translateY(${Math.min(pullDistance * 0.3, 50)}px)`;
          pullElement.style.opacity = '0.7';
        }
      }
    };

    const handleTouchEnd = () => {
      if (isPulling && pullElement) {
        pullElement.style.transform = '';
        pullElement.style.opacity = '';
        
        setRefreshing(true);
        getCustomer().finally(() => {
          setRefreshing(false);
          toast.success("Data refreshed", { autoClose: 1500 });
        });
        
        isPulling = false;
      }
    };

    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchmove', handleTouchMove, { passive: true });
    document.addEventListener('touchend', handleTouchEnd, { passive: true });

    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [pwaMode, mobilePWA]);

  useEffect(() => {
    getCustomer();
    // Check PWA mode, mobile, and webview
    setPwaMode(isPWA());
    setMobilePWA(isMobilePWA());
    setWebViewMode(isWebView());
  }, []);

  // Handle window resize for mobile detection
  useEffect(() => {
    const checkMobile = () => {
      const isMobileViewport = window.innerWidth <= 768;
      const isMobileUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      // Only show mobile view if both conditions are true AND it's not a desktop browser
      const isDesktopBrowser = !isMobileUserAgent && window.innerWidth > 1024;
      const isMobile = isMobileViewport && isMobileUserAgent && !isDesktopBrowser;
      setIsMobile(isMobile);
      
      // Debug logging
      console.log('Customers - Mobile Detection:', {
        isMobile,
        isMobileViewport,
        isMobileUserAgent,
        isDesktopBrowser,
        windowWidth: window.innerWidth,
        userAgent: navigator.userAgent,
        pwaMode,
        webViewMode
      });
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, [pwaMode, webViewMode]);
  return (
    <>
      {(pwaMode || (isMobile && !webViewMode)) && (
        <div className="pwa-header bg-primary text-white p-3 mb-3">
          <div className="d-flex align-items-center justify-content-between">
            <h4 className="mb-0">
              <i className="simple-icon-people me-2"></i>
              Customers ({customerData.length})
            </h4>
            <div className="d-flex align-items-center gap-2">
              {!isOnline && (
                <div className="pwa-status-indicator bg-warning">
                  <i className="simple-icon-wifi me-1"></i>
                  Offline
                </div>
              )}
              {mobilePWA && (
                <div className="pwa-status-indicator">
                  <i className="simple-icon-screen-smartphone me-1"></i>
                  PWA
                </div>
              )}
              {refreshing && (
                <div className="pwa-status-indicator bg-info">
                  <i className="simple-icon-refresh me-1"></i>
                  Refreshing
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      
      <div className={`row ${(pwaMode || (isMobile && !webViewMode)) ? 'pwa-content' : ''}`}>
        {!(pwaMode || (isMobile && !webViewMode)) && (
          <>
        <div className="col-4">
          <h1>Customers <small className="me-2">({customerData.length})</small></h1>
          {webViewMode && (
            <small className="text-muted">
              <i className="simple-icon-screen-smartphone me-1"></i>
              WebView Mode
            </small>
          )}
        </div>
        <div className="col-8">
          <div className="d-flex align-items-center  justify-content-end">
            <div className="col-md-5 mb-0 mr-2">
              <div className="form-group mb-0 mr-2">
                <input
                  type="text"
                  value={searchValue}
                  onChange={handleSearchChange}
                  className="form-control"
                  placeholder="Search by Name ..."
                />
              </div>
            </div>
            <Link to={"/customers/add"} className="btn btn-primary">
              <i className="simple-icon-plus me-2" aria-hidden="true"></i> Add Customer
            </Link>
          </div>
        </div>
          </>
        )}
        
        {(pwaMode || (isMobile && !webViewMode)) && (
          <div className="col-12">
            <div className="pwa-search-section mb-3">
              <div className="input-group">
                <input
                  type="text"
                  value={searchValue}
                  onChange={handleSearchChange}
                  className="form-control form-control-lg"
                  placeholder="Search customers by name..."
                />
                <button className="btn btn-outline-secondary" type="button">
                  <i className="simple-icon-magnifier"></i>
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="col-sm-12">
          {(pwaMode || (isMobile && !webViewMode)) ? (
            // PWA Mobile Card Layout
            <div className="pwa-customer-list">
              {pwaMode && mobilePWA && (
                <div className="pwa-pull-hint text-center text-muted mb-3">
                  <small>
                    <i className="simple-icon-arrow-down me-1"></i>
                    Pull down to refresh
                  </small>
                </div>
              )}
              {loading && <Loader></Loader>}
              {!loading && (
                <div>
                  {customerData.map((row, key) => {
                    return (
                      <div key={key} className="pwa-customer-card mb-3">
                        <div className="card">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-start mb-2">
                              <div>
                                <h6 className="card-title mb-1">{row.name}</h6>
                                <small className="text-muted">#{key + 1}</small>
                              </div>
                              <div className="pwa-status-badge">
                                {row.customer_status === 1 ? (
                                  <span className="badge bg-success">Active</span>
                                ) : (
                                  <span className="badge bg-warning">Pending</span>
                                )}
                              </div>
                            </div>
                            
                            <div className="pwa-customer-details mb-3">
                              <div className="row">
                                <div className="col-6">
                                  <small className="text-muted d-block">Email</small>
                                  <small>{row.email}</small>
                                </div>
                                <div className="col-6">
                                  <small className="text-muted d-block">Contact</small>
                                  <small>{row.contact_no}</small>
                                </div>
                              </div>
                              <div className="mt-2">
                                <small className="text-muted d-block">Location</small>
                                <small>{row.city_name}, {row.state_name}</small>
                              </div>
                            </div>
                            
                            <div className="pwa-actions">
                              <div className="btn-group w-100" role="group">
                                <Link 
                                  to={"/customers/edit/" + row.id} 
                                  className="btn btn-outline-primary btn-sm"
                                >
                                  <i className="simple-icon-pencil me-1"></i> Edit
                                </Link>
                                {row.customer_status === 0 ? (
                                  <button 
                                    onClick={() => approveCustomer(row, 1)} 
                                    className="btn btn-outline-success btn-sm"
                                  >
                                    <i className="simple-icon-check me-1"></i> Approve
                                  </button>
                                ) : (
                                  <button 
                                    onClick={() => approveCustomer(row, 0)} 
                                    className="btn btn-outline-warning btn-sm"
                                  >
                                    <i className="simple-icon-close me-1"></i> Block
                                  </button>
                                )}
                                <button 
                                  onClick={() => deleteCustomer(row)} 
                                  className="btn btn-outline-danger btn-sm"
                                >
                                  <i className="simple-icon-trash me-1"></i> Delete
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  
                  {customerData.length === 0 && (
                    <div className="text-center py-5">
                      <i className="simple-icon-people" style={{fontSize: '3rem'}}></i>
                      <h5>No customers found</h5>
                      <p className="text-muted">Start by adding your first customer</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          ) : (
            // Original Desktop Table Layout
            <div className="card">
              <div className="card-body p-0">
              {loading && <Loader></Loader>}
              {!loading && (
                <div>
                  <div className="table-responsive">
                    <table className="table">
                      <thead className="">
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Contact</th>
                          <th>Location</th>
                          <th
                            className="text-center"
                            style={{ width: "200px" }}
                          >
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {customerData.map((row, key) => {
                          return (
                            <tr key={key}>
                              <td>{key + 1}</td>
                              <td>{row.name}</td>
                              <td>{row.email}</td>
                              <td>{row.contact_no}</td>
                              <td>{row.city_name}, {row.state_name}</td>
                              <td className="d-flex justify-content-center gap-2" style={{ width: "200px" }}>
                                <Link to={"/customers/edit/" + row.id} className="btn btn-sm btn-secondary mr-2">
                                  <i className="fa fa-edit me-1"></i> Edit
                                </Link>
                                {row.customer_status === 0 ? <button onClick={() => approveCustomer(row, 1)} className="btn btn-sm btn-success mr-2">
                                  <i className="fa fa-check me-1"></i> Approve
                                </button> :
                                  <button onClick={() => approveCustomer(row, 0)} className="btn btn-sm btn-danger mr-2">
                                    <i className="fa fa-trash me-1"></i> Block
                                  </button>}
                                <button onClick={() => deleteCustomer(row)} className="btn btn-sm btn-danger">
                                  <i className="fa fa-trash me-1"></i> Delete
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
          )}
        </div>
      </div>
      
      {/* PWA Floating Action Button */}
      {(pwaMode || (isMobile && !webViewMode)) && (
        <Link 
          to={"/customers/add"} 
          className="btn btn-primary pwa-fab position-fixed rounded-circle shadow-lg"
          style={{
            bottom: '100px',
            right: '20px',
            width: '60px',
            height: '60px',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px'
          }}
        >
          <i className="simple-icon-plus"></i>
        </Link>
      )}
    </>
  );
};

export default Customers;
